import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class ProductAttributeGroup extends BaseEntity{

    productAttributeGroupCode : string;
    productCode               : string;
    productAttributeCode      : string;
    profileCode               : string;
    theValue                  : number;
    
}

//
